import React from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';

interface EmailConfirmationMobileProps {
  arrow?: React.ReactNode;
  content?: React.ReactNode;
  message: string;
}

const DialogDesktop: React.FC<EmailConfirmationMobileProps> = ({ arrow, content, message }) => {
  return (
    <div className="bg-gray-100 pt-[22px] pl-[38px] pb-[32px] pr-[30px] shadow-lg z-10 w-[520px] relative">
      <div className="flex flex-col gap-m">
        <AiOutlineInfoCircle size="32" />
        <p className="display-4 text-primary ">{message}</p>
        {content && <p className="lead">{content}</p>}
      </div>
      {arrow}
    </div>
  );
};

export default DialogDesktop;
